import ContractAppService from '../../../../application/platform/scp/contract/contract-app-service';
import { FileAttachmentsTable } from '../../shared/file-attachments-table';
import { FileAttachmentsService } from '../../shared/use-file-attachments';

const CONTRACT_FILES_SERVICE: FileAttachmentsService = {
    documentTypeGroup: 3,
    list: (id) => ContractAppService.listContractFiles({ id, page: 1, pageSize: 200 }).then((response) => response.items || []),
    add: ContractAppService.addFileContract,
    remove: ContractAppService.deleteFileContract,
};

export default function ContractFileDataTable({ contractId }: { contractId?: string }) {
    return <FileAttachmentsTable entityId={contractId ? Number(contractId) : undefined} service={CONTRACT_FILES_SERVICE} uploadId="file-upload-document" />;
}
